import { PlusOutlined, SearchOutlined } from "@ant-design/icons"
import { unwrapResult } from "@reduxjs/toolkit"
import { Button, Col, Form, Input, Modal, notification, Row, Select, Space } from "antd"
import React, { ReactElement, useContext, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../app/store"
import { EditableList } from "../../compnents/list/EditableList"
import { OperatingRoomParams } from "../../services/operatingRoom"
import { ThemeContext } from "../../theme/ThemeContext"
import {
  AXIOS_IP_REPORTCARD,
} from "./reportCardSlice"
import { ReportCardColumns } from "./column"
import { TabBar, TabPane } from "../../compnents/widgets/TabBar"
import { DateRangeType, DateSelect, getDateRange } from "../../compnents/form/DateSelect"
import { ReportCardModal } from "./reportCardModal"
import { ReportCardDetailModal } from "./reportCardDetai"
import { getSJWHTokenAsync } from "../dataMaintenance/organization/data"
import axios from "axios"
import moment from "moment"
import { selectTenantCategory, selectTenantCountyCode } from "../../app/applicationSlice"

const { Option } = Select

interface ReportCardManagementProps {
  onChange?: (id: string) => void
}
export const ReportCardManagement = ({
  onChange,
}: ReportCardManagementProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [isDetailModalVisible, setIsDetailModalVisible] = useState(false)

  const tenantCategory = useSelector(selectTenantCategory)

  const tenantCountyCode = useSelector(selectTenantCountyCode)

  const [token, setToken] = useState<any>()
  // const [token, setToken] = useState("wpayP1lQgJSVWGZqD/dS2JgJQ==")

  const [total, setTotal] = useState<any>()

  const [data, setData] = useState<any[]>([])

  const [pageLoading, setPageLoading] = useState(false) //表格 loading

  const [isChecked, setIsChecked] = useState(false)

  const [id, setId] = useState<any>()

  const [typelist, setTypelist] = useState<any>() // 多个分类

  const [diseaselist, setDiseaselist] = useState<any>([]) //传染病

  const [head, tail] = getDateRange(DateRangeType.ThisMonth)

  const [params, setParams] = useState<any>({
    pageSize: 10,
    pageNo: 1,
    reportTimeHead: head,
    reportTimeTail: tail,
    bk_dateRange: 3
  })

  const changeFormat = (date: any) => {
    if (date) {
      return moment(date)?.format("YYYY-MM-DD HH:mm:ss")
    }
    return ''
  }

  const getData = () => {
    if(tenantCountyCode != '330206') {
      notification.error({
        message: "您所在的尚未配置服务地址，请联系管理员处理。",
        duration: 3,
      })
      return
    }
    setPageLoading(true)
    dispatch(getSJWHTokenAsync())
      .then(unwrapResult)
      .then((tokenRes) => {
        setToken(tokenRes)
        axios({
          url: `${AXIOS_IP_REPORTCARD}/emr/diseaseReport/list`,
          headers: {
            "Content-Type": "application/json",
            "His-Auth": tokenRes,
          },
          withCredentials: false,
          method: "POST",
          data: { 
            ...params,
            reportTime: params?.reportTimeHead ? 
              [changeFormat(params.reportTimeHead), changeFormat(params.reportTimeTail)] : ['', ''],
            diagnosisDate: params?.diagnosisDateHead ? 
              [changeFormat(params.diagnosisDateHead), changeFormat(params.diagnosisDateTail)] : ['', ''],
            reportTimeHead: undefined,
            reportTimeTail: undefined,
            diagnosisDateHead: undefined,
            diagnosisDateTail: undefined,
            bk_dateRange: undefined,
            jz_dateRange: undefined,
           },
        }).then((res) => {
          setData(res.data.data?.records || res.data.data?.list)
          setTotal(res.data.data?.total)
          setPageLoading(false)
        })
        if(!token) {
          axios({
            url: `${AXIOS_IP_REPORTCARD}/system/dictData/getDicListByDicTypes`,
            headers: {
              "Content-Type": "application/json",
              "His-Auth": tokenRes,
            },
            withCredentials: false,
            method: "POST",
            data: ['report_card_category', 'report_card_status', 'report_first_case_classification']
          }).then(res => {
            setTypelist(res.data.data)
          })

          axios({
            url: `${AXIOS_IP_REPORTCARD}/emr/diseaseReport/getDiseaseName`,
            headers: {
              "Content-Type": "application/json",
              "His-Auth": tokenRes,
            },
            withCredentials: false,
            method: "POST",
          }).then(res => {
            setDiseaselist(res.data.data || [])
          })
        }
      })
  }

  useEffect(() => {
    getData()
  }, [params])

  return (
    <TabBar defaultActiveKey={"1"} style={{ margin: "10px 20px" }}>
      <TabPane key="1" tab="报卡管理">
        <Col
          style={{
            height: "calc(100% - 30px)",
            overflow: "hidden",
            position: "relative",
            marginTop: 10,
            marginBottom: 10,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Col
            style={{
              flex: 1,
              backgroundColor: theme.pn,
              borderRadius: 10,
              padding: "20px 15px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Form
              form={form}
              autoComplete="off"
              initialValues={{
                bk_dateRange: 3,
                reportTimeHead: head,
                reportTimeTail: tail,
              }}
              onFinish={(values) => {
                setParams({ ...params, ...values, pageNo: 1 })
              }}
            >
              <Row
                align="middle"
                justify="space-between"
                style={{ marginBottom: 10 }}
              >
                <Space>
                  {tenantCategory == 6 && <Form.Item name="orgCodeOrOrgName" noStyle>
                    <Input
                      placeholder="机构名称/机构唯一码"
                      style={{ width: 240 }}
                      allowClear
                      onChange={form.submit}
                    />
                  </Form.Item>}
                  <Form.Item name="nameOrPhone" noStyle>
                    <Input
                      placeholder="患者姓名/手机号/身份证号"
                      style={{ width: 240 }}
                      allowClear
                      onChange={form.submit}
                    />
                  </Form.Item>
                  <Form.Item name="diagnosisDate" noStyle>
                    <DateSelect
                      placeholder="就诊时间"
                      style={{ width: "9rem" }}
                      onChange={form.submit}
                      labelPrefix=""
                      namePrefix="diagnosisDate"
                      onlyTime="jz"
                    />
                  </Form.Item>
                  <Form.Item name="category" noStyle>
                    <Select
                      placeholder="报卡类别"
                      allowClear
                      onChange={form.submit}
                    >
                      {
                        typelist?.['report_card_category']?.map((v: any) => {
                          return (
                            <Select.Option key={v?.id} value={v?.value}>{v?.label}</Select.Option>
                          )
                        })
                      }
                    </Select>
                  </Form.Item>
                  <Form.Item name="reportTime" noStyle>
                    <DateSelect
                      placeholder="报卡时间"
                      style={{ width: "9rem" }}
                      onChange={form.submit}
                      labelPrefix=""
                      namePrefix="reportTime"
                      onlyTime="bk"
                    />
                  </Form.Item>
                  <Form.Item name="firstCaseClassification" noStyle>
                    <Select
                      placeholder="病历分类"
                      allowClear
                      onChange={form.submit}
                      style={{ width: '8rem' }}
                    >
                      {
                        typelist?.['report_first_case_classification']?.map((v: any) => {
                          return (
                            <Select.Option key={v?.id} value={v?.value}>{v?.label}</Select.Option>
                          )
                        })
                      }
                    </Select>
                  </Form.Item>
                  <Form.Item name="diseaseName" noStyle>
                    <Select
                      placeholder="传染病名称"
                      allowClear
                      style={{ width: '8rem' }}
                      onChange={form.submit}
                    >
                      {
                        diseaselist?.map((v: any) => {
                          return (
                            <Select.Option key={v?.id} value={v?.id || v?.diseaseName}>{v?.diseaseName}</Select.Option>
                          )
                        })
                      }
                    </Select>
                  </Form.Item>
                  <Form.Item name="reportStatus" noStyle>
                    <Select
                      placeholder="报卡状态"
                      allowClear
                      onChange={form.submit}
                    >
                      {
                        typelist?.['report_card_status']?.map((v: any) => {
                          return (
                            <Select.Option key={v?.id} value={v?.value}>{v?.label}</Select.Option>
                          )
                        })
                      }
                    </Select>
                  </Form.Item>
                  <Button
                    type="primary"
                    onClick={form.submit}
                    loading={pageLoading}
                  >
                    查询
                  </Button>
                </Space>
                <Space>
                  {tenantCategory != 6 && <Button
                    type="primary"
                    onClick={() => {
                      if(tenantCountyCode != '330206') {
                        notification.error({
                          message: "您所在的尚未配置服务地址，请联系管理员处理。",
                          duration: 3,
                        })
                        return
                      }
                      setIsModalVisible(true)
                    }}
                  >
                    登记报卡
                  </Button>}
                </Space>
              </Row>
            </Form>
            <EditableList
              page={{
                items: data,
                current: params.pageNo,
                size: params.pageSize,
                total: total,
              }}
              loading={pageLoading}
              columns={ReportCardColumns((v, d) => {
                switch (v) {
                  case 'detail':
                    setId(d.id)
                    setIsChecked(false)
                    setIsDetailModalVisible(true)
                    break
                  case 'accept':
                    setId(d.id)
                    setIsChecked(true)
                    setIsDetailModalVisible(true)
                    break
                  case 'revoke':
                    Modal.confirm({
                      title: '提示',
                      content: '确定要撤销报卡吗？',
                      okText: '确定',
                      cancelText: '取消',
                      onOk: () => {
                        axios({
                          url: `${AXIOS_IP_REPORTCARD}/emr/diseaseReport/review`,
                          headers: {
                            "Content-Type": "application/json",
                            "His-Auth": token,
                          },
                          withCredentials: false,
                          method: "POST",
                          data: { 
                            id: d?.id,
                            reportStatus: 1
                          },
                        }).then(() => {
                          notification.success({
                            message: '撤销成功',
                          })
                          getData()
                        })
                      },
                    })
                    break
                }
              }, params.pageSize * (params.pageNo - 1))}
              onChangePage={(current: any, size: any) => {
                setParams({ ...params, pageNo: current, pageSize: size })
              }}
              onRow={(r: any) => ({
                onDoubleClick: () => {
                  setId(r?.id)
                  setIsChecked(false)
                  setIsDetailModalVisible(true)
                },
              })}
            />
          </Col>
        </Col>

        <ReportCardModal
          visible={isModalVisible}
          token={token}
          onOk={() => {
            setIsModalVisible(false)
            getData()
          }}
          onCancel={() => setIsModalVisible(false)}
        />

        <ReportCardDetailModal
          id={id}
          type={isChecked}
          token={token}
          visible={isDetailModalVisible}
          onOk={() => {
            setIsDetailModalVisible(false)
            if(isChecked) {
              getData()
            }
          }}
          onCancel={() => setIsDetailModalVisible(false)}
        />
      </TabPane>
    </TabBar>
  )
}
